import { colors } from "@permisso/permisso-components";
import { Spinner } from "src/apps/components/spinner/Spinner";

import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { useTheme } from "src/apps/providers/ThemeStore";
import styled from "styled-components";

export const ProcessingOrderBoxUploader = () => {
  const { primaryColor } = useTheme();
  return (
    <Container>
      <Spinner color={primaryColor} size={5} />
    </Container>
  );
};

const Container = styled.div`
  min-height: 4.6875rem;
  display: flex;
  flex: 1;
  background-color: ${colors.grey200};
  border-radius: 0.375rem;
  justify-content: center;
  align-items: center;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    min-height: 3.5625rem;
  }
`;
